<template>
  <div class="alertcontent" v-if="dialogVisible">
    <div class="alertcontentdiv">
      <div class="alertcontentdiv_head">
        <p>{{modalTitle}}</p>
        <div>
          <i class="el-icon-close" @click="cancel"></i>
        </div>
      </div>
      <div class="alertcontentdiv_params">
        <div class="content-params">
          <!-- 角色名称 -->
          <div class="params">
            <label class="custom_label">角色名称：</label>
            <span style="min-width:210px"><el-input v-model="name" placeholder="请输入角色名称" ></el-input></span>
          </div>
          <el-button type="primary" icon="el-icon-search"  size="mini" @click="search">搜索</el-button>
        </div>
      </div>
      <div class="alertcontentdiv_table">
        <el-table ref="multipleTable" :data="dataList" class="checkTabel"
                  :highlight-current-row="true" @select-all="selectAll" @select="userSelect"
                  tooltip-effect="dark" style="width: 100%"  border height=100%>
          <!--<div  slot="empty" v-if="emptyErrorText" :class="loading?'':'empty-err'">{{loading?'暂无数据':emptyErrorText}}</div>-->
          <el-table-column center align="center" type="selection" width="55"></el-table-column>
          <el-table-column center align="center" type="index" width="55" :label="'序号'"></el-table-column>

          <el-table-column v-for="(item,index) in tableColumns" :key="index" :prop="item.name" align="center" :label="item.label" show-overflow-tooltip center>
            <template slot-scope="scope">{{item.formatter ? item.formatter(scope.row[item.name], scope.row, index) : scope.row[item.name]}}</template>
          </el-table-column>
        </el-table>
      </div>
      <div class="alertcontentdiv_page" v-if="hasPage">
        <div>
          总共<font style="color:#409EFF">{{totalRows}}</font>条记录
        </div>
        <!--<el-pagination layout="prev, pager, next" :total="totalRows"  :current-page="pageNo" :page-size="pageSize" @current-change="currentChangeType">-->
        <!--</el-pagination>-->
      </div>
      <div class="alertcontentdiv_buttom">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirm">确认</el-button>
      </div>
    </div>
  </div>
</template>
<script>
  // import * as Api from '@/api/promotion.js'
  import { methodPost } from '../../api/request'
  function requried(column) {
    throw new Error(`缺少参数[${column}]`)
  }
  import MCTB from '@/utils/MultipleCheckTableBack.js'
  export default {
    name: 'SearchDialog',
    props: {
      modalTitle: String,
      data: Array,
      dialogVisible: {
        type: Boolean,
        default: false
      }
    },
    components: {},
    data() {
      return {
        multipleSelection: [],
        MCTB: null,
        show: false,
        loading: false,
        hasPage: true,
        dlgTitle: '',
        placeholder: '',
        searchValue: '',
        selectId: '', // 选中的id
        selectedItem: {},
        pageNo: 1, // 当前页码
        pageSize: 20, // 每页多少条数据
        totalRows: 0, // 总共多少数据
        tableColumns: [],
        dataList: [ // 数据源
        ],
        initCheckboxVal: [], // 回显
        emptyErrorText: '',
        name: '',
        filialeOptions: [
        ],
        searchFieldName: '',
        filialeurl: '', // 分公司url,
        filialeOpen: false // 是否需要分公司下拉框
      }
    },
    created() {
    },
    methods: {
      async open({
        dlgTitle,
        url = requried('url'),
        selectId,
        emptyErrorText = '',
        initCheckboxVal = [],
        searchFieldName = 'roleName',
        additionalParams,
        emptyMessage = '暂无数据',
        pageNo = 1,
        pageSize = 20,
        tableColumns = requried('tableColumns'),
        idField = 'id',
        hasPage = true,
        filialeSelect = {},
        placeholder
      }) {
        this.show = true;
        this.hasPage = hasPage;
        this.dlgTitle = dlgTitle;
        this.url = url;
        this.multipleSelection = JSON.parse(JSON.stringify(initCheckboxVal)) || []
        this.emptyErrorText = emptyErrorText
        this.selectId = selectId;
        this.additionalParams = additionalParams;
        this.emptyMessage = emptyMessage;
        this.searchFieldName = searchFieldName;
        this.pageNo = pageNo;
        this.pageSize = pageSize;
        this.tableColumns = tableColumns;
        this.idField = idField;
        this.placeholder = placeholder;
        this.filialeurl = filialeSelect.filialeurl;
        this.filialeOpen = filialeSelect.filialeOpen;
        this.MCTB = new MCTB({
          vueComponent: this,
          tableName: 'multipleTable', // 需要操作的table名字
          multipleSelection: this.multipleSelection, // 已选中的需要回显的初始值
          defaultKey: 'id', // 需要判断的id和回显的名称
          defaultName: 'roleName',
          tableData: this.dataList // 表格的数据
        })
        const params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize
        }
        if (this.filialeOpen) {
          const { data } = await this.getDataFiliale()
          this.filialeOptions = data
          this.filialeValue = ''
          params.wwDcompanyCode = ''
        }
        return new Promise((resolve, reject) => {
          this.getData(params).then(() => {
            this.selectedItem = this.dataList.find(o => o[this.idField] === this.selectId) || {};
            this.resolve = resolve;
            this.reject = reject;
          })
        })
      },
      // 用户点击操作时记录
      userSelect(selection, row) {
        this.MCTB.userSelectChange(selection, row)
      },
      // 全选
      selectAll(selection) {
        this.MCTB.userSelectAll(selection, this.dataList)
      },
      handleSelectionChange(val) {
        // this.multipleSelection = val;
      },
      getData(params) {
        this.loading = true
        return methodPost(this.url, {
          ...params,
          ...this.additionalParams
        }).then(res => {
          this.loading = false
          const { code, data, message } = res
          if (code !== 0) {
            this.$message(message)
          } else {
            const resData = data.data ? data.data : data;
            if (resData.length > 0) {
              this.dataList = resData.map(o => {
                const item = {
                  ...o
                }
                this.tableColumns.forEach((c, index) => {
                  if (c.translater) {
                    item[c.name] = c.translater(item[c.name], item, index)
                  }
                })
                return item;
              })
              this.$nextTick(() => {
                this.MCTB.setBackShow(this.dataList)
                // this.toggleSelctionRows(this.multipleSelection)
              })
              if (this.hasPage) {
                this.totalRows = data.totalRows
              }
            } else {
              this.dataList = []
              this.totalRows = 0
            }
          }
        })
      },
      search() {
        this.dataList = []
        this.searchData(1)
      },
      confirm() {
        const selection = this.MCTB.getMultipleSelection()
        if (selection && selection.length < 1) {
          this.$message.error('请选择角色')
        } else {
          this.$emit("confirm-select-item", selection);
          this.reset()
        }
      },
      reset() {
        this.MCTB = null
        this.name = ''
        this.dataList = []
        this.totalRows = 0
      },
      searchData(flag) {
        let params = {}
        this.pageNo = flag ? this.pageNo : 1
        params = {
          [this.searchFieldName]: this.name,
          pageNo: this.pageNo,
          pageSize: this.pageSize
        }
        if (this.filialeOpen) {
          params.wwDcompanyCode = this.filialeValue
        }
        this.getData(params)
      },
      cancel() {
        this.reset()
        this.$emit("close");
      }
    }
  }
</script>

<style type="text/scss" lang="scss" scoped>
  .empty-err{
    text-align: center;
    color: red
  }
  .alertcontent {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index:9;
    .alertcontentdiv {
      position: absolute;
      left: calc(50% + 90px);
      top: 50%;
      transform: translate(-50%, -50%);
      width: 900px;
      height: 660px;
      padding: 20px;
      // padding-top: 0;
      background: #fff;
      display: flex;
      flex-direction: column;
      .el-icon-close {
        font-size: 20px;
        cursor: pointer;
      }
      .alertcontentdiv_head {
        display: flex;
        align-items: center;
        position: relative;
        padding-bottom: 10px;
        border-bottom: 1px solid #ddd;
        p {
          height: 30px;
          line-height: 30px;
          font-size: 18px;
          font-weight: bold;
        }
        &>div {
          position: absolute;
          right: 10px;
        }
      }

      .alertcontentdiv_table {
        flex:1;
        overflow-y: auto;
      }
      .alertcontentdiv_page {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        div:nth-of-type(1) {
          font-size: 14px;
        }
        .el-pagination {
          float: right;
        }
      }
      .alertcontentdiv_buttom {
        height: 32px;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/components/tabel-role-checkbox.vue